import React, { Component } from 'react';
import { api } from '../services/rest';
import MenuItem from '../components/Menu/MenuItem';
import { NavLink } from 'react-router-dom';//, Link, HashRouter as Router, 
import { session as currentSession } from '../authentication/session';

class NewProject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            adminIds: [],
            settings: {
                gulp: {
                    ftpUser: "",
                    ftpPassword: "",
                    ftpHost: "",
                    ftpRemoteFolder: "",
                    useGulp: false
                },
                buildSSG: {
                    name: "",
                    description: "",
                    keywords: "",
                    perPage: false
                }
            },
            saved: false
        }
        this.onlyOne = this.onlyOne.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleGulpCheckChange = this.handleGulpCheckChange.bind(this);
        this.clientName = React.createRef();
        this.ftpUser = React.createRef();
        this.ftpPassword = React.createRef();
        this.ftpHost = React.createRef();
        this.ftpRemoteFolder = React.createRef();
        this.useGulp = React.createRef();
        this.buildName = React.createRef();
        this.buildDescription = React.createRef();
        this.buildKeywords = React.createRef();
        this.perPage = React.createRef();
        this.loginName = React.createRef();
        this.loginEmail = React.createRef();
        this.loginPassword = React.createRef();
    }
    componentDidMount() {
        api.get("/Projects/Index")
            .then(res => this.setState({ projects: res.data }));
        api.get("/Projects/AdminIds")
            .then(res => this.setState({ adminIds: res.data }));
    }

    onlyOne(projects) {
        return projects.length === 1 &&
            projects[0].subMenuItems.length === 1
    }

    onSubmit() {
        var currentUser = currentSession.getUser()
        var createString = "CreateProject::" + this.refs.clientName.value + "::gulpData[" + this.refs.ftpUser.value + "??" + this.refs.ftpPassword.value + "??" + this.refs.ftpHost.value + "??" + this.refs.ftpRemoteFolder.value + "??" + this.refs.useGulp.checked.toString() + "]::buildData[" + this.refs.buildName.value + "??" + this.refs.buildDescription.value + "??" + this.refs.buildKeywords.value + "??" + this.refs.perPage.checked.toString() + "]::" + this.refs.loginName.value + "::"+ this.refs.loginEmail.value + "::" + this.refs.loginPassword.value + "::" + currentUser.id ;
        
        fetch(`/api/Projects/`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                'Access-Control-Allow-Origin': '*'
            },
            body: JSON.stringify(createString)
        })
            .then(api.get("/Projects/Index")
                .then(res => this.setState({ projects: res.data })))
            .then(this.resetForm());
    }

    handleGulpCheckChange(event) {
        var settings = this.state.settings;
        settings.gulp.useGulp = event.target.checked;
        this.setState({
            settings: settings
        })
    }

    handleCheckChange(event) {
        var settings = this.state.settings;
        settings.buildSSG.perPage = event.target.checked;
        this.setState({
            settings: settings
        })
    }

    resetForm() {
        this.refs.clientName.value = "";
        this.refs.ftpUser.value = "";
        this.refs.ftpPassword.value = "";
        this.refs.ftpHost.value = "";
        this.refs.ftpRemoteFolder.value = "";
        this.refs.useGulp.value = true;
        this.refs.buildName.value = "";
        this.refs.buildDescription.value = "";
        this.refs.buildKeywords.value = "";
        this.refs.perPage.value = false;
        this.refs.loginName.value = "";
        this.refs.loginEmail.value = "";
        this.refs.loginPassword.value = "";
    }

    render() {
        //console.log(this.state.projects);
        //var items = this.state.projects.map(item => <div> {item.subMenuItems.map(project => <Link to={`${project.url}`}><strong>{item.text}</strong></Link>)}</div>);
        var items = this.state.projects.map(item => <MenuItem item={item} key={item.text} url={item.subMenuItems[0].url} />);
        var currentUser = currentSession.getUser();
        var newProject = (this.state.adminIds.find(x => x === currentUser.id)) ?
            <li key={this.props.text}>
                <NavLink activeClassName="active" to={`/NewProject`}>New Project</NavLink>
            </li> : "";
        if (this.state.projects.length === 0) {
            return <div></div>
        }
        //else if (this.onlyOne(this.state.projects)) {
        //    //return <Redirect to={this.state.projects[0].subMenuItems[0].url} />
        //}
        else {
            return (
                <div>
                    <div className="sidebar sidebar-inverse pr-0 pl-0">
                        <ul className="nav sidebar-nav ">{items}{newProject}</ul>
                    </div>
                    <div className="sidebar-offset container-fluid">
                        <h1>New Project</h1>
                        <form>
                            <div style={{ width: 35 + '%', textAlign: 'right' }}>
                                <label>Client Name: </label><input ref="clientName" id="clientName" style={{ width: 80 + '%', marginLeft:'10px' }} /> <br /><br />
                            </div>
                            <h3>Configuration: </h3>
                            <br /><br />
                            <div style={{ width: 35 + '%', textAlign: 'right'}}>
                                <label>FTP User: </label><input ref="ftpUser" id="ftpUser" style={{ width: 80 + '%', marginLeft: '10px' }}  /><br /><br />
                                <label>FTP Password: </label><input ref="ftpPassword" id="ftpPassword" type="password" style={{ width: 80 + '%', marginLeft: '10px' }} /><br /><br />
                                <label>FTP Host: </label><input ref="ftpHost" id="ftpHost" style={{ width: 80 + '%', marginLeft: '10px' }} /><br /><br />
                                <label>Remote Folder: </label><input ref="ftpRemoteFolder" id="ftpRemoteFolder" style={{ width: 80 + '%', marginLeft: '10px' }} /><br />
                                <label>Use Gulp: </label><input ref="useGulp" type="checkbox" id="useGulp" style={{ width: 80 + '%', marginLeft: '10px' }} checked={this.state.settings["gulp"].useGulp} onChange={(event) => this.handleGulpCheckChange(event)} /><br />
                            </div><br />
                            <h3>Site Meta: </h3>
                            <br /><br />
                            <div style={{ width: 35 + '%', textAlign: 'right' }}>
                                <label>Per-Page Tags: </label><input type="checkbox" ref="perPage" id="perPage" style={{ width: 80 + '%', marginLeft: '10px' }} defaultValue={this.state.settings["buildSSG"].perPage} onChange={(event) => this.handleCheckChange(event)} /><br /><br />
                                <label>Name: </label><input ref="buildName" id="buildName" style={{ width: 80 + '%', marginLeft: '10px' }} /><br /><br />
                                <label>Description: </label><textarea ref="buildDescription" id="buildDescription" style={{ width: 80 + '%', marginLeft: '10px' }} /><br /><br />
                                <label>Keywords: </label><textarea ref="buildKeywords" id="buildKeywords" style={{ width: 80 + '%', marginLeft: '10px' }} /><br /><br />
                            </div>
                            <br /><br />
                            <h3>Client Login Details: </h3>
                            <br /><br />
                            <div style={{ width: 35 + '%', textAlign: 'right' }}>
                                <label>Username: </label><input ref="loginName" id="buildName" style={{ width: 80 + '%', marginLeft: '10px' }} /><br /><br />
                                <label>Email: </label><input ref="loginEmail" id="buildDescription" style={{ width: 80 + '%', marginLeft: '10px' }} /><br /><br />
                                <label>Password: </label><input ref="loginPassword" id="buildKeywords" type="password" style={{ width: 80 + '%', marginLeft: '10px' }} /><br /><br />
                            </div>
                            <br />
                            <input type="button" value="Create Project" onClick={this.onSubmit}/>
                        </form>
                    </div>
                </div>
            )
        }
    }
}

export default NewProject;